/**
 * The vue-js-modal settings of `V2ModalOption` (the option group editor),
 * shared by every screen that opens it. A function: the width cap follows
 * the window when it opens.
 */
export function modalOptionSettings() {
  return {
    name: 'option',
    adaptive: true,
    classes: 'dialog--height-limit',
    height: 'auto',
    scrollable: true,
    maxWidth: window.innerWidth * 0.95,
    width: 700,
    clickToClose: false,
  };
}
